import React from 'react'
import './lg-card.css'

const LGCard = props => {
    return (
        <div className='lg-card-container'>
            <span className='lg-card-label'>{props.data.label}</span>
            <span className='lg-card-value'>{props.data.value}</span>
        </div>
    )
}

export default LGCard